const BACKEND = {
  JOB_ORCHESTRATOR: 'jobOrchestrator',
  DATAWS: 'dataws',
  IMPORT_EXPORT_ORCHESTRATOR: 'importExportOrchestrator'
}

function getBackend(format) {
  if (format && format.backend) return format.backend
  return format && format.typeOfImport ? BACKEND.DATAWS : BACKEND.JOB_ORCHESTRATOR
}

/**
 * Auto-detecing a format assumes only a single format is detected. Now that we have V2 formats going
 * through the Import Export Orchestrator, those should be ignored for now until V1 formats are deprecated
 * then we switch detectable to the orchestrator formats.
 */
function isDetectable(format) {
  return getBackend(format) !== BACKEND.IMPORT_EXPORT_ORCHESTRATOR
}

function getAllowedExtensions(format, settings) {
  if (format && Array.isArray(format.fileExtensions) && format.fileExtensions.length) {
    return format.fileExtensions
  }
  return (settings && settings.fileExtensions) || []
}

function getAllSupportedExtensions(importConfig) {
  const entry = (importConfig && importConfig[0]) || {}
  const settings = entry.settings || {}
  const extensions = [...(settings.fileExtensions || [])]

  const groups = entry.conversionInputOptions || []
  groups.forEach(group => {
    ;(group.inputFormatTypes || []).forEach(format => {
      ;(format.fileExtensions || []).forEach(extension => {
        if (!extensions.includes(extension)) extensions.push(extension)
      })
    })
  })

  return extensions
}

function requiresProjectStep(format) {
  return !format || format.requiresProjectStep !== false
}

/**
 * DataWS converts a file into one dataset and imports a single project out of it, so a file holding
 * several has no safe outcome there. The Job Orchestrator writes a separate converted file per
 * project and the import step sends them one at a time, so several projects are normal - a Delfland
 * analysis CSV yields one per measurement point.
 */
function allowsMultipleProjects(format) {
  return getBackend(format) === BACKEND.JOB_ORCHESTRATOR
}

function getPostConvertChecks(format) {
  return (format && format.postConvertChecks) || []
}

function isFormatSelected(format) {
  return Boolean(format && (format.inputFormatType || format.typeOfImport))
}

function getFormatsForExtension(importConfig, extension) {
  const entry = (importConfig && importConfig[0]) || {}
  const settings = entry.settings || {}
  const wanted = String(extension || '').toLowerCase()

  return (entry.conversionInputOptions || [])
    .reduce((formats, group) => formats.concat(group.inputFormatTypes || []), [])
    .filter(format => getAllowedExtensions(format, settings).includes(wanted))
}

function isBinaryContent(format) {
  return Boolean(format && format.binaryContent)
}

export default {
  BACKEND,
  getBackend,
  isDetectable,
  getAllowedExtensions,
  getAllSupportedExtensions,
  getFormatsForExtension,
  isBinaryContent,
  requiresProjectStep,
  allowsMultipleProjects,
  getPostConvertChecks,
  isFormatSelected
}
